import React from "react";
import theme from "theme";
import { Theme, Image, LinkBox, Link, Box, Structure, Text, Section, Icon } from "@quarkly/widgets";
import { Helmet } from "react-helmet";
import { GlobalQuarklyPageStyles } from "global-page-styles";
import { RawHtml, Override } from "@quarkly/components";
import * as Components from "components";
import { FaTelegram } from "react-icons/fa";
export default (() => {
	return <Theme theme={theme}>
		<GlobalQuarklyPageStyles pageUrl={"create-logo"} />
		<Helmet>
			<title>
				Конструктор верхней части бота
			</title>
			<meta name={"description"} content={"Здесь вы можете оформить шапку вашего бота (логотип, кнопку, ссылки)"} />
			<meta property={"og:title"} content={"Конструктор верхней части бота"} />
			<meta property={"og:description"} content={"Здесь вы можете оформить шапку вашего бота (логотип, кнопку, ссылки)"} />
			<meta property={"og:image"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/1.jpg?v=2022-12-25T20:50:47.139Z"} />
			<link rel={"shortcut icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} type={"image/x-icon"} />
			<link rel={"apple-touch-icon"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"76x76"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-icon"} sizes={"152x152"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<link rel={"apple-touch-startup-image"} href={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileImage"} content={"https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z"} />
			<meta name={"msapplication-TileColor"} content={"#000000"} />
		</Helmet>
		<Structure
			cells-number-total="2"
			quarkly-title="Navbar"
			position="relative"
			z-index="3"
			nout-z-index="9"
		>
			<Override
				slot="Content"
				grid-template-columns="3fr 1fr"
				nout-grid-template-columns="3fr 2fr"
				lg-grid-template-columns="1fr 1fr"
				md-grid-template-columns="1fr 2fr"
				sm-grid-template-columns="1fr"
				display="grid"
			>
				<Override slot="cell-0">
					<LinkBox href="/">
						<Image src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/ucoz%201.svg?v=2022-07-18T14:33:40.269Z" display="block" />
					</LinkBox>
					<Components.QuarklycommunityKitMobileSidePanel menuPosition="right" breakpoint="nout">
						<Override
							slot="Content"
							background="rgba(255, 255, 255, 0)"
							md-background="--background"
							padding="8px 16px 8px 16px"
							nout-z-index="9999"
							nout-background="--background"
							justify-content="flex-start"
						/>
						<Override slot="Button Icon" size="32px" />
						<Override slot="Button Text" nout-text-transform="uppercase" nout-font="normal 500 16px/200% &quot;Montserrat&quot;, sans-serif" nout-letter-spacing="1px" />
						<Override slot="Wrapper" nout-z-index="9" />
						<Box
							width="100%"
							display="flex"
							grid-gap="32px"
							md-flex-direction="column"
							nout-flex-direction="column"
							nout-margin="20px 0px 0px 0px"
							nout-grid-gap="16px"
						>
							<Link
								href="/instrukciya/#shop"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Создание интернет-магазина
							</Link>
							<Link
								href="/instrukciya/#bot"
								color="#000000"
								font="--menu"
								text-decoration-line="initial"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Подключение бота
							</Link>
							<Link
								href="/instrukciya/#pay"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Онлайн оплата
							</Link>
							<Link
								href="/instrukciya/#faq"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								FAQ
							</Link>
						</Box>
						<Box
							display="none"
							sm-display="flex"
							sm-flex-direction="column"
							sm-align-items="flex-start"
							sm-grid-gap="16px"
							sm-margin="16px 0px 0px 0px"
						>
							<Link
								href="/instrukciya"
								color="#000000"
								text-decoration-line="initial"
								font="--menu"
								transition="--opacityOut"
								hover-opacity=".8"
							>
								Инструкция
							</Link>
							<Link
								href="https://t.me/uShopWebBot"
								color="--white"
								font="--button"
								text-decoration-line="initial"
								padding="12px 24px 12px 24px"
								background="--dark"
								border-radius="50px"
								transition="--opacityOut"
								hover-opacity=".8"
								target="_blank"
								md-padding="12px 20px 12px 20px"
								sm-align-self="center"
								sm-margin="20px 0px 0px 0px"
							>
								Создать веб-бота
							</Link>
						</Box>
					</Components.QuarklycommunityKitMobileSidePanel>
				</Override>
				<Override
					slot="Cell 0th"
					align-items="center"
					justify-content="flex-end"
					grid-gap="24px"
					display="flex"
					md-display="flex"
					md-grid-gap="16px"
				/>
				<Override slot="cell-1">
					<Link
						href="https://t.me/uShopWebBot?start=web"
						color="--white"
						font="--button"
						text-decoration-line="initial"
						padding="12px 24px 12px 24px"
						background="--dark"
						border-radius="50px"
						transition="--opacityOut"
						hover-opacity=".8"
						target="_blank"
						md-padding="12px 20px 12px 20px"
					>
						Создать веб-бота
					</Link>
				</Override>
				<Override slot="Cell 1" sm-display="none" />
			</Override>
		</Structure>
		<Section padding="140px 0 140px 0" background="linear-gradient(0deg,rgba(2, 2, 2, 0.58) 0%,rgba(2, 2, 2, 0.58) 100%),rgba(0, 0, 0, 0) url(https://images.unsplash.com/photo-1587654780291-39c9404d746b?ixlib=rb-4.0.3&q=85&fm=jpg&crop=entropy&cs=srgb&w=2000) center center/cover repeat scroll padding-box" sm-padding="120px 0 120px 0">
			<Override slot="SectionContent" align-items="flex-start" md-align-items="center" />
			<Text
				margin="0px 0px 0px 0px"
				font="--headline1"
				md-font="normal 800 32px/1.4 &quot;Montserrat&quot;, sans-serif"
				sm-font="normal 800 24px/1.4 &quot;Montserrat&quot;, sans-serif"
				color="--white"
				as="h1"
				md-text-align="center"
			>
				Конструктор логотипа
			</Text>
			<Text margin="8px 0px 48px 0px" font="--headline3" color="--white" md-text-align="center">
				Генератор для облегченного управление верхней частью сайта
			</Text>
			<Link
				href="https://t.me/Dolce_bot"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
				text-align="center"
			>
				Пример бота с логотипом
			</Link>
		</Section>
		<Section padding="60px 0 60px 0" sm-padding="30px 0 30px 0" md-padding="30px 0 90px 0">
			<Components.LogoComponent />
			<Text margin="20px 0px 0px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Заполните поля своими данными и получите готовый код шапки для вашего бот-магазина
				<br />
				<br />
				Чтобы получить ссылку на логотип, вы можете загрузить вашу картинку в "Файловый менеджер" и полученную ссылку установить в первое поле:
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/filemanager.png?v=2023-11-06T20:51:28.405Z"
				display="block"
				border-width="1px"
				border-color="--color-dark"
				border-style="solid"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/filemanager.png?v=2023-11-06T20%3A51%3A28.405Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/filemanager.png?v=2023-11-06T20%3A51%3A28.405Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/filemanager.png?v=2023-11-06T20%3A51%3A28.405Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/filemanager.png?v=2023-11-06T20%3A51%3A28.405Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/filemanager.png?v=2023-11-06T20%3A51%3A28.405Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/filemanager.png?v=2023-11-06T20%3A51%3A28.405Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/filemanager.png?v=2023-11-06T20%3A51%3A28.405Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
			<Text margin="20px 0px 8px 0px" font="--base" sm-font="normal 500 14px/160% &quot;Montserrat&quot;, sans-serif" color="--dark">
				Полученный код, вы полностью заменяете здесь:
			</Text>
			<Image
				src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/shapkahtmlk.png?v=2023-11-08T17:04:07.838Z"
				display="block"
				border-width="1px"
				border-style="solid"
				border-color="--color-dark"
				srcSet="https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/shapkahtmlk.png?v=2023-11-08T17%3A04%3A07.838Z&quality=85&w=500 500w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/shapkahtmlk.png?v=2023-11-08T17%3A04%3A07.838Z&quality=85&w=800 800w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/shapkahtmlk.png?v=2023-11-08T17%3A04%3A07.838Z&quality=85&w=1080 1080w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/shapkahtmlk.png?v=2023-11-08T17%3A04%3A07.838Z&quality=85&w=1600 1600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/shapkahtmlk.png?v=2023-11-08T17%3A04%3A07.838Z&quality=85&w=2000 2000w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/shapkahtmlk.png?v=2023-11-08T17%3A04%3A07.838Z&quality=85&w=2600 2600w,https://smartuploads.quarkly.io/62ab65c921e43d0020961286/images/shapkahtmlk.png?v=2023-11-08T17%3A04%3A07.838Z&quality=85&w=3200 3200w"
				sizes="(max-width: 576px) 100vw,(max-width: 768px) 100vw,(max-width: 992px) 100vw,(max-width: 1200px) 100vw,100vw"
			/>
		</Section>
		<Section background="--dark" padding="125px 0 125px 0" nout-padding="60px 0 60px 0" position="relative">
			<Override
				slot="SectionContent"
				display="flex"
				align-items="flex-start"
				md-align-items="center"
				md-justify-content="center"
				md-text-align="center"
			/>
			<Text
				margin="0px 0px 24px 0px"
				color="--white"
				font="--headline1"
				nout-font="normal 800 36px/1.4 &quot;Montserrat&quot;, sans-serif"
				lg-font="normal 800 26px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-font="normal 800 22px/1.4 &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 800 20px/1.4 &quot;Montserrat&quot;, sans-serif"
				as="h2"
			>
				Нет времени самому разбираться в создании бота? Можем сделать бот-магазин под ключ за 9800 руб.
			</Text>
			<Text
				margin="0px 0px 48px 0px"
				color="--white"
				font="--decsr"
				md-font="normal 500 16px/180% &quot;Montserrat&quot;, sans-serif"
				md-text-align="center"
				sm-font="normal 500 14px/180% &quot;Montserrat&quot;, sans-serif"
			>
				Создание сайтов, магазинов, порталов и лендингов под ключ. Помощь по сайтам,
				<br />
				SEO-продвижение и консультации с вебмастерами.
			</Text>
			<Link
				href="https://bot.divly.pro/"
				color="--white"
				font="--button"
				text-decoration-line="initial"
				padding="16px 28px 16px 28px"
				background="--primary"
				border-radius="50px"
				transition="background-color --transitionDuration-normal --transitionTimingFunction-easeOut 0s"
				hover-color="--dark"
				hover-background="--white"
				target="_blank"
			>
				Заказать веб-бот под ключ
			</Link>
		</Section>
		<Section
			background="--dark"
			padding="15px 0 15px 0"
			border-style="solid"
			border-color="--color-white"
			border-width="1px 0px 0px 0px"
			position="relative"
		>
			<Override
				slot="SectionContent"
				display="flex"
				align-items="center"
				flex-direction="row"
				grid-gap="16px"
				justify-content="space-between"
				md-flex-direction="column"
				md-align-items="center"
			/>
			<Box>
				<Text margin="0px 0px 0px 0px" color="--white" font="--base">
					<Link
						href="https://ukit.group/"
						color="--white"
						text-decoration-line="initial"
						target="_blank"
						hover-text-decoration-line="underline"
						padding="5px 5px 5px 5px"
					>
						© uKit Group
					</Link>
				</Text>
			</Box>
			<Box
				display="flex"
				grid-gap="32px"
				sm-flex-direction="column"
				sm-display="flex"
				sm-grid-gap="8px"
			>
				<Link
					href="https://www.ucoz.ru/details/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Юридическая информация
					<Link href="https://www.ucoz.ru/details/" />
				</Link>
				<Link
					href="https://www.ucoz.ru/terms/"
					color="--white"
					font="--base"
					target="_blank"
					text-decoration-line="initial"
					hover-text-decoration-line="underline"
					sm-text-align="center"
					padding="5px 5px 5px 5px"
				>
					Условия использования
				</Link>
			</Box>
			<LinkBox href="https://t.me/uShopWeb" target="_blank" transition="--opacityOut" hover-opacity="0.7">
				<Icon category="fa" icon={FaTelegram} size="24px" color="--white" />
			</LinkBox>
		</Section>
		<Components.EmbedHTML />
		<RawHtml>
			<style place={"endOfHead"} rawKey={"62ab65c921e43d0020961284"}>
				{":root {\n  box-sizing: border-box;\n}\n\n* {\n  box-sizing: inherit;\n    scroll-behavior: smooth;\n}\nbody {\n    position: relative !important;\n}"}
			</style>
			<script place={"endOfBody"} rawKey={"639c57f598af799c2def4641"}>
				{"   (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};\n   m[i].l=1*new Date();\n   for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}\n   k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})\n   (window, document, \"script\", \"https://mc.yandex.ru/metrika/tag.js\", \"ym\");\n\n   ym(91719479, \"init\", {\n        clickmap:true,\n        trackLinks:true,\n        accurateTrackBounce:true,\n        webvisor:true\n   });"}
			</script>
			<script place={"endOfHead"} rawKey={"65b906fcebf1ff7fe82ff95a"}>
				{"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','GTM-59QRNH');"}
			</script>
			<script async={true} src={"//code.jivo.ru/widget/EsmX5tZp4R"} place={"endOfHead"} rawKey={"69b7f73f921c1a779c7c2cc6"} />
			<style place={"endOfHead"} rawKey={"6547e6ba86f9757a91f38c0f"}>
				{"\n.uShopWebBotlogo {\n    font: var(--qtheme-font-menu);\n}\n\n.uShopWebBotlogo div {\n    font: var(--qtheme-font-menu);\n}\n.uShopWebBotlogo input[type=\"text\"] {\n    padding: 14px 11px;\n    margin-bottom: 5px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n}\n.uShopWebBotlogo .result-container h3 {\n    font-size: 16px;\n    margin-bottom: 10px;\n    font-weight: 500;\n}\n.uShopWebBotlogo img.shop-dark {\n    display: none;\n}\n.dark-theme .uShopWebBotlogo img.shop-dark {\n    display: block;\n}\n\n.dark-theme .uShopWebBotlogo img.shop-ligha {\n    display: none;\n}\n.uShopWebBotlogo {\n    margin-top: 55px;\n}\n  .uShopWebBotlogo #form {\n    padding: 16px;\n  }\n  \n  .uShopWebBotlogo #result,\n  .uShopWebBotlogo #form {\n    background-color: #f7f7f7;\n  }\n  \n  .uShopWebBotlogo #form {\n    background: linear-gradient(180deg, #F7F7F7 0%, #FFF 25%);\n  }\n  .uShopWebBotlogo .result-container {\n    border-radius: 0px 0px 10px 10px;\n}\n  \n  .uShopWebBotlogo .shoptg {\n    display: flex;\n    flex-direction: column;\n  }\n  .container.buttonlogo {\n    display: flex;\n    flex-direction: row;\n}\n\n.uShopWebBotlogo .container.buttonlogo button {\n    width: 48%;\n}\n.container.buttonlogo .uShopWebBotlogoheidh {\n    width: 4%;\n}\n  .uShopWebBotlogo #resulttg {\n    border-bottom: 1px solid #f7f7f7;\n  }\n  \n  .uShopWebBotlogo .shop-header__name {\n    text-align: left;\n  }\n  \n  .uShopWebBotlogo #form {\n    margin: 0 auto;\n    text-align: center;\n  }\n  \n  .uShopWebBotlogo .shop-header {\n    padding: 16px!important;\n  }\n  \n  .uShopWebBotlogo .shop-header-link {\n    align-items: center;\n    background: #007aff!important;\n    border-radius: 8px;\n    color: var(--tgs-white);\n    display: flex;\n    gap: 4px;\n    justify-content: flex-start;\n    padding: 8px 10px;\n    text-decoration: none;\n    color: white!important;\n  }\n  \n  .uShopWebBotlogo label {\n    display: block;\n    margin-bottom: 5px;\n  }\n  \n  \n  .uShopWebBotlogo button {\n    display: inline-block;\n    padding: 10px 20px;\n    background-color: #333;\n    color: #fff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n  }\n  \n  .uShopWebBotlogo .shop-header {\n    align-items: center;\n    display: flex;\n    gap: 12px;\n    justify-content: flex-start;\n  }\n  \n  .uShopWebBotlogo .header > .shop-header {\n    margin-bottom: var(--tgs-indent-s);\n  }\n  \n  .shop-header-link {\n    align-items: center;\n    background: var(--tgs-main-color);\n    border-radius: 8px;\n    color: var(--tgs-white);\n    display: flex;\n    gap: 4px;\n    justify-content: flex-start;\n    padding: 6px 12px;\n    text-decoration: none;\n  }\n  \n  .uShopWebBotlogo .shop-header__logo {\n    --logo-size: 45px;\n    flex: 0 0 var(--logo-size);\n  }\n  \n  .uShopWebBotlogo .shop-header__logo img {\n    height: var(--logo-size);\n    object-fit: contain;\n    width: var(--logo-size);\n  }\n  \n  .uShopWebBotlogo .shop-header__name {\n    flex: 1 1;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    letter-spacing: -.34px;\n    line-height: 129%;\n  }\n  \n  .uShopWebBotlogo .menubar .shop-header__links {\n    display: none;\n  }\n  .container.buttonlogo {\n    display: flex;\n    justify-content: space-between;\n    max-width: 375px;\n    margin: 0 auto;\n    font-family: Arial, sans-serif;\n    flex-direction: row;\n}\n.uShopWebBotlogo .container {\n    display: flex;\n    justify-content: space-between;\n    max-width: 420px;\n    margin: 0 auto;\n    font-family: Arial, sans-serif;\n    flex-direction: column;\n}\n  \n  .uShopWebBotlogo .form-container {\n    flex: 1;\n    border-radius: 10px;\n  }\n  \n  .uShopWebBotlogo form {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .uShopWebBotlogo label {\n    font-size: 14px;\n    margin-bottom: 5px;\n    color: #333;\n  }\n  \n  .uShopWebBotlogo input {\n    padding: 10px;\n    margin-bottom: 15px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 14px;\n  }\n  \n  .uShopWebBotlogo #generateBtn {\n   background: var(--qtheme-color-primary);\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n   width: 100%;\n  }\n  \n  .uShopWebBotlogo #generateBtn:hover {\n    background-color: #0056b3;\n  }\n  \n  .uShopWebBotlogo .result-container {\n    padding: 16px;\n    background-color: #f7f7f7;\n  }\n  \n.uShopWebBotlogo textarea {\n    width: calc(100% - 32px);\n    padding: 0px 16px;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    font-size: 14px;\n    resize: none;\n    height: 200px;\n}\n  \n  .uShopWebBotlogo #copyBtn {\n    background-color: var(--qtheme-background-dark);\n    color: #fff;\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    width: 100%;\n  }\n  \n  .uShopWebBotlogo #copyBtn:hover {\n    background-color: #0056b3;\n  }\n  .uShopWebBotlogo .container.buttonlogo {\n    display: flex;\n    flex-direction: column;\n    margin: 0;\n    gap: 5px;\n    margin-top: 10px;\n}\n\n\n\n.uShopWebBotlogo .theme-switch {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    width: 195px;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.uShopWebBotlogo #theme-toggle {\n    display: none;\n}\n\n.uShopWebBotlogo #theme-toggle + label {\n    width: 40px;\n    height: 20px;\n    background-color: #ddd;\n    border-radius: 20px;\n    display: inline-block;\n    position: relative;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.uShopWebBotlogo #theme-toggle:checked + label {\n    background-color: #007BFF;\n}\n\n.uShopWebBotlogo #theme-toggle + label::before {\n    content: '';\n    width: 20px;\n    height: 20px;\n    background-color: #fff;\n    border-radius: 50%;\n    position: absolute;\n    left: 0;\n    transition: transform 0.3s;\n}\n\n.uShopWebBotlogo #theme-toggle:checked + label::before {\n    transform: translateX(20px);\n}\n.dark-theme .uShopWebBotlogo div#result {\n    background-color: #323232;\n}\n\n.dark-theme .uShopWebBotlogo div#form {\n    background: linear-gradient(180deg, #323232 0%, #1c1c1c 25%);\n}\n\n.dark-theme .uShopWebBotlogo form#form {\n    background: linear-gradient(180deg, #323232 0%, #000 25%);\n}\n\n.dark-theme .uShopWebBotlogo .shop-header__name {\n    color: #ececec;\n}\n\n.dark-theme .uShopWebBotlogo .result-container {\n    background-color: #000000;\n}\n\n.dark-theme .uShopWebBotlogo h3 {\n    color: white;\n}\n\n.dark-theme .uShopWebBotlogo div#resulttg {\n    border-bottom: 1px solid #4e4848;\n}\n.uShopWebBotlogo .shoptg {\n    pointer-events: none;\n}\n@media screen and (max-width: 960px) {\n.uShopWebBotlogo .theme-switch {\n    position: absolute;\n    top: 20px;\n    left: 5%;\n    right: 5%;\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n    width: 90%;\n    flex-direction: row;\n    justify-content: space-between;\n    flex-wrap: nowrap;\n    margin: auto;\n}\n}\n.uShopWebBotlogo #resulttg {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n.uShopWebBotlogo {\n    padding-top: 74px;\n    position: relative;\n    overflow: hidden;\n    background-color: #e6e6e6;\n    margin-top: 0;\n    padding-bottom: 60px;\n}\nbody.dark-theme .uShopWebBotlogo {\n    background-color: #292929!important;\n}\nbody.dark-theme .theme-switch {\n    color: white;\n}\n.dark-theme .uShopWebBotlogo div#resulttg {\n    border-bottom: 1px solid #4e4848;\n}\n.dark-theme .uShopWebBotlogo input[type=\"text\"] {\n    border: 1px solid #474747;\n    border-radius: 6px;\n    background-color: #1c1c1c;\n    color: white;\n}\n\n.dark-theme .uShopWebBotlogo textarea {\n    border: 1px solid #474747;\n    border-radius: 6px;\n    background-color: #1c1c1c;\n    color: white;\n}\n.uShopWebBotlogo .shoptg {\n    pointer-events: none;\n}\n.dark-theme .uShopWebBotlogo form#form {\n    background: linear-gradient(180deg, #323232 0%, #323232 25%);\n}\n.dark-theme .uShopWebBotlogo .result-container {\n    background-color: #323232;\n}\n.uShopWebBotlogo .result-container h3 {\n    margin: 0;\n    margin-bottom: 16px;\n}\n\n.uShopWebBotlogo textarea {\n    width: 100%;\n}\n.uShopWebBotlogo textarea,\n.uShopWebBotlogo input[type=\"text\" i] {outline: -webkit-focus-ring-color auto 0px;outline-color: transparent;border: 1px solid #474747;}\n\n.uShopWebBotlogo .result-container {\n    background-color: #ffffff;\n}\n\n.uShopWebBotlogo .container {\n    border-radius: 10px;\n    box-shadow: 0px 40px 28px 0px rgb(0 0 0 / 6%);\n}\n.uShopWebBotlogo .theme-switch {\n    position: absolute;\n}\n.uShopWebBotlogo #form {\n    z-index: 1;\n    position: relative;\n    padding-bottom: 20px;\n    margin-bottom: -10px;\n}\n.uShopWebBotlogo {\n    border-width: 1px;\n    border-color: var(--qtheme-color-dark);\n    border-style: solid;\n}\nbutton#resetBtn {\n    color: #fff;\n   background: var(--qtheme-color-red);\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    width: 100%;\n}\nbutton#resetBtn:hover {\n   background: var(--qtheme-color-dark);\n}\n.uShopWebBotlogo .shop-header__logo {\n    height: var(--logo-size);\n    object-fit: contain;\n    width: var(--logo-size);\n}"}
			</style>
		</RawHtml>
	</Theme>;
});